import http from './httpClient';

class SettingsService {
  // Business settings
  static async getSettings(businessId, keys = []) {
    const query = keys && keys.length ? `?keys=${encodeURIComponent(keys.join(','))}` : '';
    return http.get(`/settings/${businessId}${query}`);
  }

  static async upsertSettings(businessId, settings = []) {
    return http.put(`/settings/${businessId}`, { settings });
  }

  // Notification preferences
  static async getNotificationPreferences(businessId, userId) {
    return http.get(`/settings/${businessId}/notification-preferences?userId=${userId}`);
  }

  static async updateNotificationPreferences(businessId, userId, preferences) {
    return http.put(`/settings/${businessId}/notification-preferences`, { userId, preferences });
  }

  // Payment methods
  static async listPaymentMethods(businessId) {
    return http.get(`/settings/${businessId}/payment-methods`);
  }

  static async addPaymentMethod(businessId, { method_name, description }) {
    return http.post(`/settings/${businessId}/payment-methods`, { method_name, description });
  }

  static async deletePaymentMethod(id) {
    return http.delete(`/settings/payment-methods/${id}`);
  }

  // Inventory helpers
  static async fixNegativeStockWithLatestPrices(businessId) {
    return http.post('/stock-in/v2/negative-stock/fix-latest', { businessId });
  }
}

export default SettingsService;
